import type { ChipBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';
import { filterOptions, toggleValues, withDefaultWhenEmpty } from '@/app/common/filters/core/filterOptionSelection.ts';

export const optionChips: ChipBehaviour = {
  options: filterOptions,
  toggle: (filter, values) => withDefaultWhenEmpty(toggleValues(filter, values)),
};
